const FORBIDDEN_STATUS = 403;

/** Raised when a drive browser request fails or returns an unexpected shape. */
export class DriveBrowserError extends Error {
  readonly status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = "DriveBrowserError";
    this.status = status;
  }

  /** True when the drive provider rejected the connection and the user must reconnect. */
  get isReconnectRequired(): boolean {
    return this.status === FORBIDDEN_STATUS;
  }
}
